<template>
    <div>
      <p>现代骨病主要分为三类：结构性、内脏型和颅骨型。在Centro生物能源公司，我们专注于结构性骨病。</p>
      <p><strong>结构性骨病:</strong>本节旨在了解肌肉骨骼系统。因此，研究身体运动的三个基本支柱：骨骼、肌肉和关节，以及它们如何相互作用以实现复杂的运动。反过来，研究软组织的整个框架，如筋膜、肌腱或韧带。一旦知道了所有这些，就分析了如何纠正该系统可能发生的变化及其校正。一般来说，这一部分分为上半身和下半身，以便于学习。</p>
      <p>整骨者用来减轻各种疾病的各种技术。以下是使用最广泛的技术之一：</p>
      <p>-肌筋膜松解：包括松解筋膜，筋膜是软组织周围的组织，当它被附着和限制时会产生疼痛和活动性受限。</p>

      <p> -肌肉能量技术：这是一种利用患者肌肉主动和自动收缩的技术，以可控的方向和可变的强度，面对治疗师施加的某种阻力。它被用来治疗缩短或痉挛的肌肉，加强削弱的肌肉结构，减少水肿，或恢复关节活动。</p>
    </div>
</template>

<script>
export default {
  name: 's4'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/s4.vue